<script lang="ts">
	import type { Chromosome } from "@core/schema/Chromosome.js";
	import { chromosomeNameMap } from "@core/schema/names/chromosomeNameMap.js";

	const {
		chromosome,
		active,
	}: {
		chromosome: Chromosome;
		active?: boolean;
	} = $props();
</script>

<div
	class={[
		"w-16 font-outfit aspect-square rounded-full flex items-center cursor-pointer justify-center font-medium text-md",
		active ? "bg-blue text-green" : "text-lightblue bg-white",
	]}
>
	{chromosomeNameMap[chromosome]}
</div>
